import { combineEpics } from "redux-observable";
import "./views/GarView/epics/index.js";
import analysisEpics from "./views/Analysis/epics.js";
import { garModuleEpic } from "./views/GarView/epics/epics.js";
const rootEpic = combineEpics(
  garModuleEpic,
  //analysis epics below
  analysisEpics
);
export {
  rootEpic as default,
  rootEpic
};
//# sourceMappingURL=epics.js.map
